import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { getCollectionSuggests } from '../../../data-layer/collections/service';
import { toCollectionPersistenceUI } from '../../../mappers/collections/toCollectionPersistenceUI';
import { EditCollectionDrawer } from '../../../ui/users/EditCollectionDrawer/EditCollectionDrawer';
import { contentActionsService } from '../../../utils/ContentActionsService/ContentActionsService';
import { useEventSource } from '../../../utils/LocationContext';
import { EventSource } from '../../../utils/analyticsService';
import { useBackButton } from '../../../utils/useBackButton';
import { useCollectionInfo } from '../hooks/useCollectionInfo';
import { useCollection } from '../useCollection';
import { useUpdateCollectionInfo } from './hooks/useUpdateCollectionInfo';
import { validateSubmit } from './utils/validateSubmit';

export function EditCollectionDialog() {
    const { state, pathname } = useLocation();
    const { collectionModel } = useCollection({ collectionId: state?.collectionId });
    const { eventSource } = useEventSource();
    const onNavigateBack = useBackButton(pathname);

    const screen = eventSource ?? EventSource.COLLECTION;

    const initialValues = collectionModel ? toCollectionPersistenceUI(collectionModel) : undefined;

    const { values, handlers } = useCollectionInfo({
        initialValues,
        id: collectionModel?.id,
        getSuggestMethod: collectionModel?.id
            ? () => getCollectionSuggests(collectionModel?.id, screen)
            : undefined,
        screen,
        mode: 'edit',
    });

    const onSubmit = useUpdateCollectionInfo({ initialValues, newValues: values });

    const isSubmitValid = validateSubmit({ initialValues, values });

    const onClose = useCallback(() => {
        contentActionsService.trackCollectionEditDialogClose({
            id: collectionModel?.id ?? '',
            screen,
        });
        onNavigateBack();
    }, [collectionModel?.id, onNavigateBack, screen]);

    return (
        <EditCollectionDrawer
            values={values}
            handlers={{
                ...handlers,
                onSubmit,
            }}
            submitDisabled={!values.collectionName || !isSubmitValid}
            onClose={onClose}
        />
    );
}
